export type ForegroundPushPayload = {
  messageId?: string;
  notification?: { title?: string; body?: string };
  data?: { notificationId?: string; title?: string; body?: string; deepLink?: string };
  fcmOptions?: { link?: string };
};

export type VendorPushMessage = {
  title: string;
  body: string;
  notificationId: string | null;
  deepLink: string;
  source: "fcm" | "synthetic";
};

export const sameOriginPushPath = (value: unknown, origin: string): string => {
  if (typeof value !== "string" || !value.trim()) return "/app";
  try {
    const url = new URL(value.trim(), origin);
    if (url.origin !== origin || !["http:", "https:"].includes(url.protocol) ||
        url.username || url.password) return "/app";
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return "/app";
  }
};

export const parseForegroundPush = (
  payload: ForegroundPushPayload | null | undefined,
  origin: string,
  source: VendorPushMessage["source"],
): VendorPushMessage | null => {
  if (!payload || typeof payload !== "object") return null;
  return {
    title: payload.notification?.title || payload.data?.title || "MamiMarkets",
    body: payload.notification?.body || payload.data?.body || "You have a new notification.",
    notificationId: payload.data?.notificationId || null,
    deepLink: sameOriginPushPath(payload.data?.deepLink || payload.fcmOptions?.link, origin),
    source,
  };
};
